import {
  LITHIUM,
  COBALT,
  NICKEL,
  MANGANESE,
  NATURAL_GRAPHITE,
  SYNTHETIC_GRAPHITE,
  RARE_EARTHS,
  ELECTROLYTE,
  ANODE,
  CATHODE,
  LITHIUM_ION_BATTERIES,
  BLACK_MASS,
} from '~/constants/services/constants'

export const ALL_PRICES = [
  {
    name: LITHIUM.simplifiedName,
    icon: LITHIUM.iconLine,
  },
  {
    name: COBALT.simplifiedName,
    icon: COBALT.iconLine,
  },
  {
    name: NICKEL.simplifiedName,
    icon: NICKEL.iconLine,
  },
  {
    name: MANGANESE.simplifiedName,
    icon: MANGANESE.iconLine,
  },
  {
    name: NATURAL_GRAPHITE.simplifiedName,
    icon: NATURAL_GRAPHITE.iconLine,
  },
  {
    name: SYNTHETIC_GRAPHITE.simplifiedName,
    icon: SYNTHETIC_GRAPHITE.iconLine,
  },
  {
    name: RARE_EARTHS.simplifiedName,
    icon: RARE_EARTHS.iconLine,
  },
  {
    name: ELECTROLYTE.simplifiedName,
    icon: ELECTROLYTE.iconLine,
  },
  {
    name: ANODE.simplifiedName,
    icon: ANODE.iconLine,
  },
  {
    name: CATHODE.simplifiedName,
    icon: CATHODE.iconLine,
  },
  {
    name: LITHIUM_ION_BATTERIES.simplifiedName,
    icon: LITHIUM_ION_BATTERIES.iconLine,
  },
  {
    name: BLACK_MASS.sidebar,
    icon: BLACK_MASS.iconLine,
  },
]
